// import React, { useEffect, useRef, useState } from "react";
// import { StandardConst } from "../../Services/StandardConst";
// import TableComponent, {
//   NoRecordTemplate,
// } from "../../Services/TableComponent";
// import { useDispatch, useSelector } from "react-redux";
// import SnackbarComponent from "../../Services/SnackbarComponent";
// import DeleteConfirmAlert from "../../Services/AlertComponent";
// import { WebService } from "../../Services/WebService";
// import { ActionPermission, PageInfo } from "../PageInfo";
// import Button from "react-bootstrap/Button";
// import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
// import ActionButton from "../../Services/ActionButton";
// import { Chip } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";
// import AddEditBroadcastDocument from "./AddEditBroadcastDocument";
// import StaticListComponent from "../../Services/StaticListComponent";
// import { WSSuccessAlert } from "../../Services/WSAlert";

// const ManageBroadcastDocument = () => {
//   const refSnackbar = useRef();
//   const ref = useRef();
//   const MasterPageName = "Policy Document To All Employees";
//   const confirmMessage = MasterPageName + " Deleted successfully";
//   const AddButtonText = "Policy Document";
//   const dispatch = useDispatch();
//   PageInfo({ pageTitle: "Manage Policy Documents" });
//   const addEditModalRef = useRef();
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const [BroadcastDocuments, setBroadcastDocuments] = useState([]);
//   const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
//   const Roles = useSelector((s) => s.auth.AssignRole ?? {});

//   useEffect(() => {
//     if (state?.openModal) {
//       fnEdit(0);
//     }
//   }, [state]);

//   const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
//   const [permission, SetPermission] = useState({});
  
//   // Check if user is HR, CEO, or Admin
//   const isAuthorizedRole = () => {
//     return Roles.some(role => 
//       role === StandardConst.SystemRole.SuperAdmin || 
//       role === StandardConst.SystemRole.HR || 
//       role === StandardConst.SystemRole.CEO ||
//       role === StandardConst.SystemRole.Company
      
//     );
//   };

//   useEffect(() => {
//     const authorized = isAuthorizedRole();
//     console.log(Roles,'me kon hu',authorized )
//     SetPermission({
//       // ManageAdd: authorized && ActionPermission("Policy Document - Add"),
//       // ManageEdit: authorized && ActionPermission("Policy Document - Edit"),
//       // ManageDelete: authorized && ActionPermission("Policy Document - Delete"),
//       // ManageSend: ActionPermission("Policy Document - Send"),
//       // ManageHistory: ActionPermission("Policy Document - History"),
//       // ManageView: ActionPermission("Policy Document - View"),
//       ManageAdd: ActionPermission("Document BroadCast Template - Add"),
//             ManageEdit: ActionPermission("Document BroadCast Template - Edit"),
//             ManageDelete: ActionPermission("Document BroadCast Template - Delete"),
//             ManageSend: ActionPermission("Document BroadCast Template - Send"),
//             ManageHistory: ActionPermission("Document BroadCast Template - History"),
//             ManageView: ActionPermission("Document BroadCast Template - View"),
//     });
//   }, [permissionList, Roles]);

//   const [bData] = React.useState([
//     {
//       title: "Policy Document List",
//       hrefLink: "/ManageBroadcastDocument",
//     },
//     {
//       title: "",
//       hrefLink: "",
//     },
//   ]);

//   const fetchBroadcastDocuments = async () => {
//     const data = await WebService({
//       endPoint: `Document/GetBroadcastDocuments/`,
//       method: "get",
//       dispatch,
//     });
//     setBroadcastDocuments(data.result);
//     dispatch(ConfigurationflowStatusUpdate());
//   };

//   useEffect(() => {
//     fetchBroadcastDocuments();
//   }, []);

//   function beautifyLocalTime(utcTimestamp) {
//     const utcDate = new Date(utcTimestamp);
//     const options = {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: 'numeric',
//       second: 'numeric',
//       hour12: true,
//     };
//     return new Intl.DateTimeFormat(undefined, options).format(utcDate);
//   }

//   const onDelete = async (dr) => {
//     refSnackbar.current.setOpenSnackBar();
//     await WebService({
//       endPoint: `CommonUtility/BroadcastDocuments?BroadcastDocumentId=${dr.BroadcastDocumentId}`,
//       method: "delete",
//       dispatch,
//     });
//     WSSuccessAlert("", `Policy Document '${dr.Title}' Deleted Successfully`);
//     await fetchBroadcastDocuments();
//   };

//   const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);

//   const SendDocumentToAll = async (dr) => {
//     try {
//       const result = await WebService({
//         endPoint: `Document/SendBroadcastDocument/${dr.BroadcastDocumentId}`,
//         method: "post",
//         dispatch,
//       });
      
//       if (result.isSuccess) {
//         WSSuccessAlert("", `Document '${dr.Title}' sent to all employees successfully!`);
//         await fetchBroadcastDocuments();
//       }
//     } catch (error) {
//       console.error("Error sending Policy Document:", error);
//     }
//   };

//   const columns = [
//     {
//       Text: "Document Title",
//       Value: "Title",
//       render: (dr) => (
//         <>
//           {dr.Title}{' '}
//           <Chip
//             label="Auto-Broadcast"
//             size="small"
//             color="warning"
//           />
//         </>
//       )
//     },
//     {
//       Text: "Recipients Count",
//       Value: "TotalRecipients",
//       render: (dr) => (
//         <span className="badge bg-primary">{dr.TotalRecipients || 0} Employees</span>
//       )
//     },
//     {
//       Text: "Created By",
//       Value: "CreaterName",
//     },
//     {
//       Text: 'Created on',
//       Value: 'CreatedAt',
//       render: (dr) => (
//         <>{dr.CreatedAt && beautifyLocalTime(dr.CreatedAt)}</>
//       )
//     },
//     {
//       Text: 'Last Sent on',
//       Value: 'LastSentAt',
//       render: (dr) => (
//         <>{dr.LastSentAt ? beautifyLocalTime(dr.LastSentAt) : 'Not Sent Yet'}</>
//       )
//     },
//     {
//       Text: "Action",
//       cssClass: "text-center td-width-100",
//       style: { width: '2px' },
//       isVisiable:
//         permission.ManageEdit ||
//         permission.ManageDelete ||
//         permission.ManageSend ||
//         permission.ManageHistory ||
//         permission.ManageView,
//       render: (dr) => (
//         <>
//           {(dr.isReserved === 0 ||
//             (dr.isReserved === 1 &&
//               Roles[0] === StandardConst.SystemRole.SuperAdmin)) && (
//               <span className="d-flex col-auto">
//                 <ActionButton
//                   IconTooltip={"Send to All Employees"}
//                   IconColor='success'
//                   IconName="EmailResend"
//                   disabled={!permission.ManageSend}
//                   id={`BroadcastSend${dr.BroadcastDocumentId}`}
//                   onClick={() => {
//                     SendDocumentToAll(dr);
//                   }}
//                 />
//                 <ActionButton
//                   IconTooltip="Document Sent History"
//                   IconName="History"
//                   IconColor='primary'
//                   disabled={!permission.ManageHistory}
//                   id={`BroadcastHistory${dr.BroadcastDocumentId}`}
//                   onClick={() => {
//                     navigate("/BroadcastDocumentHistory", {
//                       state: { BroadcastDocumentId: dr.BroadcastDocumentId },
//                     });
//                   }}
//                 />
//                 <ActionButton
//                   IconName='Download'
//                   IconTooltip='Download Document'
//                   onClick={() =>
//                     window.open(
//                       `${StandardConst.apiBaseUrl}/${dr.DocumentPath}`,
//                       "_blank"
//                     )
//                   }
//                 />
//                 <ActionButton
//                   IconTooltip={"Edit Policy Document"}
//                   IconName="Edit"
//                   id={`BroadcastEdit${dr.BroadcastDocumentId}`}
//                   disabled={!permission.ManageEdit}
//                   onClick={() => {
//                     fnEdit(dr.BroadcastDocumentId);
//                   }}
//                 />
//                 <ActionButton
//                   IconTooltip="Delete Policy Document"
//                   IconName="Delete"
//                   disabled={!permission.ManageDelete}
//                   id={`BroadcastDelete${dr.BroadcastDocumentId}`}
//                   onClick={() =>
//                     ref.current.confirmAlert(
//                       "Delete",
//                       "Are You Sure",
//                       "Do you want to delete Policy Document '" + dr.Title + "' ?",
//                       dr
//                     )
//                   }
//                 />
//               </span>
//             )}
//         </>
//       ),
//     },
//   ];

//   return (
//     <>
//       <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
//       <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
//       <StaticListComponent
//         columns={columns}
//         data={BroadcastDocuments}
//         bData={bData}
//         MasterPageName={MasterPageName}
//         noRecordCss="p-0"
//         noRecordFound={
//           <NoRecordTemplate
//             headerValue="No Policy Documents Found"
//             subHeaderValue="Create a Policy Document to send to all employees automatically"
//             imageUrl={StandardConst.imageNoRecordsFound}
//             actionButton={
//               <>
//                 {permission.ManageAdd && (
//                   <Button
//                     id="NoRecordFoundAddBroadcast"
//                     variant="outline-primary"
//                     onClick={() => fnEdit(0)}
//                   >
//                     Add {AddButtonText}
//                   </Button>
//                 )}
//               </>
//             }
//           />
//         }
//         onAddEvent={() => fnEdit(0)}
//         IsAddButtonVisible={permission?.ManageAdd}
//         AddButtonText={AddButtonText}
//         isSearchRequired={true}
//         allowSerialNo={true}
//       />
//       <AddEditBroadcastDocument
//         callBackEvent={() => fetchBroadcastDocuments()}
//         ref={addEditModalRef}
//       />
//     </>
//   );
// };

// export default ManageBroadcastDocument;

// =========================================================================================



import React, { useEffect, useRef, useState } from "react";
import { StandardConst } from "../../Services/StandardConst";
import TableComponent, {
  NoRecordTemplate,
} from "../../Services/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import { WebService } from "../../Services/WebService";
import { ActionPermission, PageInfo } from "../PageInfo";
import Button from "react-bootstrap/Button";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import ActionButton from "../../Services/ActionButton";
import { Chip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AddEditBroadcastDocument from "./AddEditBroadcastDocument";
import StaticListComponent from "../../Services/StaticListComponent";
import { WSSuccessAlert } from "../../Services/WSAlert";

const ManageBroadcastDocument = () => {
  const refSnackbar = useRef();
  const ref = useRef();
  const MasterPageName = "Policy Documents List";
  const confirmMessage = MasterPageName + " Deleted successfully";
  const AddButtonText = "Policy Document";
  const dispatch = useDispatch();
  PageInfo({ pageTitle: "Manage Policy Documents" });
  const addEditModalRef = useRef();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [BroadcastDocuments, setBroadcastDocuments] = useState([]);
  const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const Roles = useSelector((s) => s.auth.AssignRole ?? {});

  useEffect(() => {
    if (state?.openModal) {
      fnEdit(0);
    }
  }, [state]);

  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const [permission, SetPermission] = useState({});
  
  // Check if user is HR, CEO, or Admin
  const isAuthorizedRole = () => {
    return Roles.some(role => 
      role === StandardConst.SystemRole.SuperAdmin || 
      role === StandardConst.SystemRole.HR || 
      role === StandardConst.SystemRole.CEO
    );
  };

  useEffect(() => {
    const authorized = isAuthorizedRole();
    SetPermission({
      ManageAdd: authorized && ActionPermission("Policy Document - Add"),
      ManageEdit: authorized && ActionPermission("Policy Document - Edit"),
      ManageDelete: authorized && ActionPermission("Policy Document - Delete"),
      ManageSend: ActionPermission("Policy Document - Send"),
      ManageHistory: ActionPermission("Policy Document - History"),
      ManageView: ActionPermission("Policy Document - View"),
    });
  }, [permissionList, Roles]);

  const [bData] = React.useState([
    {
      title: "Policy Document List",
      hrefLink: "/ManageBroadcastDocument",
    },
    {
      title: "",
      hrefLink: "",
    },
  ]);

  const fetchBroadcastDocuments = async () => {
    const data = await WebService({
      endPoint: `Document/GetBroadcastDocuments/`,
      method: "get",
      dispatch,
    });
    
    // Calculate recipient count for each document
    const documentsWithCount = await Promise.all(
      (data.result || []).map(async (doc) => {
        try {
          const statusData = await WebService({
            endPoint: `Document/GetBroadcastDocumentStatus/${doc.BroadcastDocumentId}?status=${StandardConst.Status.Approved}`,
            method: "get",
            dispatch,
          });
          
          return {
            ...doc,
            TotalRecipients: statusData?.result?.recipients?.length || 0
          };
        } catch (error) {
          console.error("Error fetching count:", error);
          return {
            ...doc,
            TotalRecipients: 0
          };
        }
      })
    );
    
    setBroadcastDocuments(documentsWithCount);
    dispatch(ConfigurationflowStatusUpdate());
  };

  useEffect(() => {
    fetchBroadcastDocuments();
  }, []);

  function beautifyLocalTime(utcTimestamp) {
    const utcDate = new Date(utcTimestamp);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    };
    return new Intl.DateTimeFormat(undefined, options).format(utcDate);
  }

  const onDelete = async (dr) => {
    refSnackbar.current.setOpenSnackBar();
    await WebService({
      endPoint: `CommonUtility/broadcast_documents?BroadcastDocumentId=${dr.BroadcastDocumentId}`,
      method: "delete",
      dispatch,
    });
    WSSuccessAlert("", `Policy Document '${dr.Title}' Deleted Successfully`);
    await fetchBroadcastDocuments();
  };

  const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);

  const SendDocumentToAll = async (dr) => {
    try {
      const result = await WebService({
        endPoint: `Document/SendBroadcastDocument/${dr.BroadcastDocumentId}`,
        method: "post",
        dispatch,
      });
      
      if (result.isSuccess) {
        WSSuccessAlert("", `Document '${dr.Title}' sent to all employees successfully!`);
        await fetchBroadcastDocuments();
      }
    } catch (error) {
      console.error("Error sending Policy Document:", error);
    }
  };

  const columns = [
    {
      Text: "Document Title",
      Value: "Title",
      render: (dr) => (
        <>
          {dr.Title}{' '}
          {/* <Chip
            label="Auto-Broadcast"
            size="small"
            color="warning"
          /> */}
        </>
      )
    },
    {
      Text: "Recipients Count",
      Value: "TotalRecipients",
      render: (dr) => (
        <span 
          className="badge bg-primary" 
          style={{ cursor: 'pointer' }}
          onClick={() => {
            navigate("/BroadcastDocumentStatus", {
              state: { BroadcastDocumentId: dr.BroadcastDocumentId, Title: dr.Title },
            });
          }}
          title="Click to view detailed status"
        >
          {dr.TotalRecipients || 0} Employees
        </span>
      )
    },
    // {
    //   Text: "Created By",
    //   Value: "CreaterName",
    // },
    {
      Text: 'Created on',
      Value: 'CreatedAt',
      render: (dr) => (
        <>{dr.CreatedAt && beautifyLocalTime(dr.CreatedAt)}</>
      )
    },
    // {
    //   Text: 'Last Sent on',
    //   Value: 'LastSentAt',
    //   render: (dr) => (
    //     <>{dr.LastSentAt ? beautifyLocalTime(dr.LastSentAt) : 'Not Sent Yet'}</>
    //   )
    // },
    {
      Text: "Action",
      cssClass: "text-center td-width-100",
      style: { width: '2px' },
      isVisiable:
        permission.ManageEdit ||
        permission.ManageDelete ||
        permission.ManageSend ||
        permission.ManageHistory ||
        permission.ManageView,
      render: (dr) => (
        <>
          {(dr.isReserved === 0 ||
            (dr.isReserved === 1 &&
              Roles[0] === StandardConst.SystemRole.SuperAdmin)) && (
              <span className="d-flex col-auto">
                {/* <ActionButton
                  IconTooltip={"Send to All Employees"}
                  IconColor='success'
                  IconName="EmailResend"
                  disabled={!permission.ManageSend}
                  id={`BroadcastSend${dr.BroadcastDocumentId}`}
                  onClick={() => {
                    SendDocumentToAll(dr);
                  }}
                />
                <ActionButton
                  IconTooltip="Document Sent History"
                  IconName="History"
                  IconColor='primary'
                  disabled={!permission.ManageHistory}
                  id={`BroadcastHistory${dr.BroadcastDocumentId}`}
                  onClick={() => {
                    navigate("/BroadcastDocumentHistory", {
                      state: { BroadcastDocumentId: dr.BroadcastDocumentId },
                    });
                  }}
                /> */}
                <ActionButton
                  IconName='Download'
                  IconTooltip='Download Document'
                  onClick={() =>
                    window.open(
                      `${StandardConst.apiBaseUrl}/uploads/${dr.DocumentPath}`,
                      "_blank"
                    )
                  }
                />
                <ActionButton
                  IconTooltip={"Edit Policy Document"}
                  IconName="Edit"
                  id={`BroadcastEdit${dr.BroadcastDocumentId}`}
                  disabled={!permission.ManageEdit}
                  onClick={() => {
                    fnEdit(dr.BroadcastDocumentId);
                  }}
                />
                <ActionButton
                  IconTooltip="Delete Policy Document"
                  IconName="Delete"
                  disabled={!permission.ManageDelete}
                  id={`BroadcastDelete${dr.BroadcastDocumentId}`}
                  onClick={() =>
                    ref.current.confirmAlert(
                      "Delete",
                      "Are You Sure",
                      "Do you want to delete Policy Document '" + dr.Title + "' ?",
                      dr
                    )
                  }
                />
              </span>
            )}
        </>
      ),
    },
  ];

  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
      <StaticListComponent
        columns={columns}
        data={BroadcastDocuments}
        bData={bData}
        MasterPageName={MasterPageName}
        noRecordCss="p-0"
        noRecordFound={
          <NoRecordTemplate
            headerValue="No Policy Documents Found"
            subHeaderValue="Create a Policy Document to send to all employees automatically"
            imageUrl={StandardConst.imageNoRecordsFound}
            actionButton={
              <>
                {/* {permission.ManageAdd && ( */}
                  <Button
                    id="NoRecordFoundAddBroadcast"
                    variant="outline-primary"
                    onClick={() => fnEdit(0)}
                  >
                    Add {AddButtonText}
                  </Button>
                {/* )} */}
              </>
            }
          />
        }
        onAddEvent={() => fnEdit(0)}
        IsAddButtonVisible={permission?.ManageAdd}
        //  IsAddButtonVisible={true}
        AddButtonText={AddButtonText}
        isSearchRequired={true}
        allowSerialNo={true}
      />
      <AddEditBroadcastDocument
        callBackEvent={() => fetchBroadcastDocuments()}
        ref={addEditModalRef}
      />
    </>
  );
};

export default ManageBroadcastDocument;